module.exports = __webpack_public_path__ + "static/media/ruler.f6ee9816.png";